export type PageType =
  | 'landing'
  | 'onboard'
  | 'billboard'
  | 'projects'
  | 'works'
  | 'texts'
  | 'members'
  | 'about'
  | 'contact'
  | 'settings'
  | 'projectDetail'
  | 'policy'
  | 'guide'
  | 'poll'
  | 'ADMIN'
  | 'ERROR';

export interface CurrentPage {
  page: PageType;
  data?: string;
}

const ARCHIVE_PAGES = [
  'billboard',
  'projects',
  'works',
  'texts',
  'members',
  'about',
  'contact',
  'settings',
  'poll',
] as const;

export const resolveCurrentPage = (pathname: string): CurrentPage => {
  if (pathname === '/') return { page: 'landing' };
  if (pathname === '/onboard') return { page: 'onboard' };
  if (pathname === '/policy' || pathname.startsWith('/policy/')) {
    return { page: 'policy' };
  }
  if (pathname === '/guide') return { page: 'guide' };
  if (pathname === '/admin' || pathname.startsWith('/admin/')) {
    return { page: 'ADMIN' };
  }
  if (pathname === '/error') return { page: 'ERROR' };

  const [, page, data] = pathname.split('/').filter(Boolean);
  if (!page) return { page: 'billboard' };
  if (page === 'projects' && data) {
    return { page: 'projectDetail', data };
  }
  if (ARCHIVE_PAGES.some((archivePage) => archivePage === page)) {
    return { page: page as typeof ARCHIVE_PAGES[number] };
  }

  return { page: 'ERROR' };
};
